import { OcrItem } from 'src/services/useGetOcrResponseApi';

export type MatchedOcrLineItem = {
  item: OcrItem;
  index: number;
};

export function getMatchingOcrLineItemsByReceiptLineItemId(
  items: { item: OcrItem }[] | undefined,
  recvReceiptLineItemId: number
): MatchedOcrLineItem[] {
  const matched: MatchedOcrLineItem[] = [];
  items?.forEach((ocrItem, index) => {
    if (ocrItem?.item?.recvReceiptLineItemId === recvReceiptLineItemId) {
      matched.push({ item: ocrItem.item, index });
    }
  });
  return matched;
}
